module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/LesMiserables_Horiz.76f5725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/LesMiserables_Horiz.jpg
// module id = RJ/4
// module chunks = 0